let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8l69A")).then(() => parcelRequire('7xkxF'));